import { ICommand } from 'core-ts-types';
import { IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { RouterHelper } from '../../../global/helpers/router_helper';
import { APDegreeMapQueryHelper } from '../../../plan/queries/ap_degree_map_query_helper';
import { APMultiTermsQuery } from '../../../plan/queries/ap_mm_terms_query';
import { CourseSlot } from '../../builders/ap_generic_slot_builder';

import { IAPAPMarkAsMetStatusDatasource } from '../mark_as_met/datasources/mark_as_met_status_datasource';
import { MarkAsMetFacade } from '../mark_as_met/facades/mark_as_met_facade';
import { APUserModeConfig } from './../../../global/components/user_mode_config/config/ap_user_mode_config';
import { INVALID_ID } from './../../../global/constants/ap_id_constants';
import { APProgramSlotHelper } from './../../../global/helpers/program_slot_helper';
import { ICourseDetailState } from './../../../routes/ap_course_details_routes';
export interface ITermEntry {
  id: number;
  name: string;
}

export interface ISaveTermPayload {
  term: number;
  program_slot: number;
  course: number;
}

class CourseTileCourseMenuController {
  private genericSlot: CourseSlot;
  private isAdvisor: boolean;
  private isFromTerm: boolean | string;
  private isPlanned: boolean = false;
  private slot: number;
  private course: any;
  private showMenu: boolean = true;
  private termId = INVALID_ID;
  private popupMenuId: string;
  private showRemoveTermOption: boolean = false;
  private showAddToTermOption: boolean = true;
  private addToTermMenuItemText = 'Add Course to Term';
  constructor(
    private ngAPUserModeConfig: APUserModeConfig,
    private routerHelper: RouterHelper,
    private saveMmCourseToTermCommand: ICommand,
    private ngAPProgramSlotHelper: APProgramSlotHelper,
    private ngAPMultiTermsQuery: APMultiTermsQuery,
    private ngAPDegreeMapQueryHelper: APDegreeMapQueryHelper,
    private loadMmAcademicPlanCommand: ICommand,
    private removeMmCourseFromTermCommand: ICommand
  ) {
    this.popupMenuId = _4.uniqueId();
  }

  isMovePreventedByMarkAsMet() {
    const programSlot = this.genericSlot.programSlot;
    if (!this.ngAPDegreeMapQueryHelper.isMarkAsMetFeatureEnabled() || _4.isEmpty(programSlot)) {
      return false;
    }
    return this.ngAPProgramSlotHelper.isMarkedAsMet(this.genericSlot.programSlot);
  }

  initialize() {
    this.isAdvisor = this.ngAPUserModeConfig.isAdvisor();
    this.isPlanned = false;
    this.showMenu = false;
    this.isFromTerm = _4.isBoolean(this.isFromTerm) ? this.isFromTerm : this.isFromTerm === 'true';
    this.showRemoveTermOption = this.isFromTerm && this.course.status === 'PLANNED';
    this.showAddToTermOption = this.isFromTerm ? this.course.status === 'PLANNED' : true;
    this.addToTermMenuItemText = this.isFromTerm ? 'Move to Term' : 'Add Course to Term';
  }
  $onInit() {
    this.initialize();
  }
  $onChanges() {
    this.initialize();
  }
  onMouseHover(event: any) {
    this.showMenu = true;
  }

  removeCourse() {
    this._removeCourseFromTerm().then((studentId: number) => {
      this.loadMmAcademicPlanCommand(studentId);
    });
  }
  _removeCourseFromTerm() {
    return this.removeMmCourseFromTermCommand(this.course.id);
  }

  _saveCourseToTerm(payload: ISaveTermPayload) {
    return this.saveMmCourseToTermCommand(payload);
  }
  moveToTerm(term: ITermEntry) {
    const { id: courseId, slotId } = this.course;
    const payload: ISaveTermPayload = {
      term: term.id,
      program_slot: slotId,
      course: this.isFromTerm ? this.course.course_id : courseId
    };
    if (this.isFromTerm) {
      this._removeCourseFromTerm().then((studentId: number) => {
        this._saveCourseToTerm(payload).then(() => {
          this.loadMmAcademicPlanCommand(studentId);
        });
      });
    } else {
      this._saveCourseToTerm(payload).then((studentId: number) => {
        this.loadMmAcademicPlanCommand(studentId);
      });
    }
  }
  showCourseDetails() {
    const _courseNk = _4.get(this.course, 'nk', INVALID_ID);
    const _courseDetailParams = {
      courseNk: _courseNk,
      courseId: this._courseId,
      termId: this.termId,
      plannedCourseId: this._plannedCourseId,
      slotId: this.course.slotId,
      showCourseDetailsMenu: true
    };
    this.routerHelper.findStateAndGo('.course_details', { courseDetailsParams: _courseDetailParams });
  }
  get _courseId() {
    return this.isFromTerm ? this.course.course_id || INVALID_ID : this.course.id;
  }
  get _plannedCourseId() {
    return this.isFromTerm ? this.course.id || INVALID_ID : INVALID_ID;
  }
}

class CourseTileCourseMenu implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;

  constructor() {
    this.bindings = {
      course: '<',
      isFromTerm: '<',
      termId: '<'
    };
    this.controller = CourseTileCourseMenuController;
    this.templateUrl =
      'capability-ng-academic-planner/src/global/components/course_tile_menu/course_tile_course_menu.html';
  }
}

angular.module('capability-ng-academic-planner').component('courseTileCourseMenu', new CourseTileCourseMenu());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_tile_menu/course_tile_course_menu.ts